import CryptoJS from 'crypto-js';

const SECRET = process.env.REACT_APP_ENCRYPTION_KEY || "AIR_SECURE_READER_V1_2024";

export const encrypt = (text) => {
  if (!text || typeof text !== 'string') return text;
  return CryptoJS.AES.encrypt(text, SECRET).toString();
};

export const decrypt = (ciphertext) => {
  if (!ciphertext || typeof ciphertext !== 'string') return ciphertext;
  // If it doesn't start with the standard AES prefix, it's likely already decrypted or plain text
  if (!ciphertext.startsWith('U2FsdGVkX1')) return ciphertext;
  try {
    const bytes = CryptoJS.AES.decrypt(ciphertext, SECRET);
    const originalText = bytes.toString(CryptoJS.enc.Utf8);
    return originalText || ciphertext;
  } catch (e) {
    return ciphertext;
  }
};

export const decryptData = (obj) => {
  if (!obj || typeof obj !== 'object' || obj === null) return obj;
  if (Array.isArray(obj)) return obj.map(decryptData);

  const sensitive = [
    'book_name', 'book_title', 'book_short_description', 
    'book_full_description', 'book_disclaimer', 'book_foreword', 
    'book_preface', 'footnote', 'memory_tickers', 'chapter_contents',
    'chapter_title', 'name', 'snippet', 'chapter_content', 'label', 'description'
  ];

  const newObj = { ...obj };
  for (const key in newObj) {
    if (sensitive.includes(key) && typeof newObj[key] === 'string') {
      newObj[key] = decrypt(newObj[key]);
    } else if (typeof newObj[key] === 'object' && newObj[key] !== null) {
      newObj[key] = decryptData(newObj[key]);
    }
  }
  return newObj;
};



// import * as CryptoJS from 'crypto-js';

// const SECRET = "AIR_SECURE_READER_V1_2024";

// export const encrypt = (text) => {
//   if (!text || typeof text !== 'string') return text;
//   return CryptoJS.AES.encrypt(text, SECRET).toString();
// };

// export const decrypt = (ciphertext) => {
//   if (!ciphertext || typeof ciphertext !== 'string') return ciphertext;
//   // If it doesn't look like a ciphertext (usually starts with U2FsdGVkX1), return as is
//   if (!ciphertext.startsWith('U2FsdGVkX1')) return ciphertext;
  
//   try {
//     const bytes = CryptoJS.AES.decrypt(ciphertext, SECRET);
//     const originalText = bytes.toString(CryptoJS.enc.Utf8);
//     // If decryption results in empty string but input was not empty, 
//     // it's likely a decryption failure (wrong key or corrupted data)
//     return originalText || ciphertext;
//   } catch (e) {
//     console.error("Decryption error:", e);
//     return ciphertext;
//   }
// };

// export const decryptData = (obj) => {
//   if (!obj || typeof obj !== 'object' || obj === null) return obj;
//   if (Array.isArray(obj)) return obj.map(decryptData);

//   const sensitive = [
//     'book_name', 'book_title', 'book_short_description', 
//     'book_full_description', 'book_disclaimer', 'book_foreword', 
//     'book_preface', 'footnote', 'memory_tickers', 'chapter_contents',
//     'chapter_title', 'name', 'snippet', 'chapter_content'
//   ];

//   const newObj = { ...obj };
//   for (const key in newObj) {
//     if (sensitive.includes(key) && typeof newObj[key] === 'string') {
//       newObj[key] = decrypt(newObj[key]);
//     } else if (typeof newObj[key] === 'object' && newObj[key] !== null) {
//       newObj[key] = decryptData(newObj[key]);
//     }
//   }
//   return newObj;
// };

